export default __webpack_public_path__ + "static/media/YT.9f0f9354.png";